import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_USER, IS_DEMO, Data } from "../config";
import { toast } from "react-toastify";

const initialState = {
  isLogin: IS_DEMO,
  currentUser: Data && Data.token ? Data : {},
  role: Data?.role,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCurrentUser(state, action) {
      state.currentUser = action.payload;
      state.isLogin = true;
      state.role = action.payload?.role || "";
    },
  },
});

export const { setCurrentUser } = authSlice.actions;

export const LogoutApi = () => async (dispatch) => {
  dispatch(setCurrentUser({}));
  dispatch(toast.success("You are Logged Out Successfully!"));
};
const authReducer = authSlice.reducer;

export default authReducer;
